// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-auth-form-container .reset-btn {
  width: 530px;
  height: 60px;
  background: #6ACE6A;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.25px;
  color: #FFFFFF;
  margin-top: 30px;
  cursor: pointer;
  border: none;
}
.gc-auth-form-container .reset-btn:hover {
  background: #7AEC7A;
}
.gc-auth-form-container .reset-btn:focus {
  background: #5CB85C;
}
.gc-auth-form-container .columnContainer {
  display: flex;
  flex-direction: column;
  color: red;
}

.password-error-text p {
  color: red;
  font-size: 12px;
  padding-left: 10px;
  line-height: 0;
  margin-bottom: 0;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}

.p-l-7 {
  padding-left: 7px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/colors.scss","webpack://./src/app/complete-new-password/complete-new-password.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEE;EACE,YAAA;EACA,YAAA;EACA,mBDOI;ECNJ,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAEJ;AADI;EACE,mBDLO;ACQb;AADI;EACE,mBDPM;ACUZ;AACE;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AACJ;;AAGE;EACE,UAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AADF;AAEE;EALF;IAMI,iBAAA;EACF;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":["/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n","@import \"../../assets/styles/colors.scss\";\n.gc-auth-form-container{\n  .reset-btn{\n    width: 530px;\n    height: 60px;\n    background: $Green;\n    border-radius: 8px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 30px;\n    text-align: center;\n    letter-spacing: -0.25px;\n    color: #FFFFFF;\n    margin-top: 30px;\n    cursor: pointer;\n    border: none;\n    &:hover{\n      background:$Greenlight;\n    }\n    &:focus{\n      background:$GreenDark;\n    }\n\n  }\n  .columnContainer{\n    display: flex;\n    flex-direction: column;\n    color: red;\n  }\n}\n.password-error-text {\n  p {\n    color: red;\n    font-size: 12px;\n    padding-left: 10px;\n    line-height: 0;\n    margin-bottom: 0;\n  }\n}\n\n.password-req{\n  font-size: 12px;\n  margin-top: 8px;\n  display: inline-block;\n  line-height: 28px;\n  @media (max-width:1640px) {\n    line-height: 16px;\n  }\n}\n\n.p-l-7 {\n  padding-left: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
